import { render, staticRenderFns } from "./BeforeAfter.vue?vue&type=template&id=0c03f31c&scoped=true"
import script from "./BeforeAfter.vue?vue&type=script&lang=js"
export * from "./BeforeAfter.vue?vue&type=script&lang=js"
import style0 from "./BeforeAfter.vue?vue&type=style&index=0&id=0c03f31c&prod&scoped=true&lang=css"
import style1 from "./BeforeAfter.vue?vue&type=style&index=1&id=0c03f31c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03f31c",
  null
  
)

export default component.exports